const type = 'CLOSE_ACCOUNT_BLOCKED_MODAL';

const closeAccountBlockedModal = () => ({
  type,
});

export { type };
export default closeAccountBlockedModal;
